import React, { Component } from "react";
import Close from "../../../../Icons/Close";
import { styles } from "../../../../ReactConst";
import { StyleRoot } from "radium";
export default class ModalDelete extends Component {
  constructor(props) {
    super(props);
    this.state = {
      styleFadeIn: true,
    };
    this.closeAddModal = this.closeAddModal.bind(this);
  }
  componentWillMount() {
    this.setState({ styleFadeIn: true });
  }

  closeAddModal = () => {
    this.setState({
      styleFadeIn: false,
    });
    setTimeout(() => {
      this.props.onClose();
    }, 400);
  };

  render() {
    const { event } = this.props;
    return (
      <StyleRoot>
        <div
          class="modal fade show modal-skin"
          id="modalDelete"
          style={
            this.state.styleFadeIn === true ? styles.bounce : styles.bounce2
          }
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <button
                type="button"
                onClick={this.closeAddModal}
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <Close className="img-fluid" alt="" />
              </button>
              <div class="modal-body">
                <section>
                  {event && event.statutEvent !== "ANNULE" ? (
                    <h5 class="modal-title">Que souhaitez-vous faire?</h5>
                  ) : (
                    <h5 class="modal-title">Supprimer l'événement</h5>
                  )}
                </section>
                <section>
                  {event && event.statutEvent !== "ANNULE" ? (
                    <h5>
                      La suppression d'un événement est définitive, les parents
                      ne seront pas avertis.
                      <br />
                      Un événement annulé restera visible aux parents invités.
                    </h5>
                  ) : (
                    <h5>Êtes-vous sûr de vouloir supprimer l'événement?</h5>
                  )}
                </section>
                <p class="bottom-space"></p>
                <div class="d-flex justify-content-center">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.handleDeleteEvent(e);
                    }}
                    class="btn-gradient btn-delete"
                    data-dismiss="modal"
                  >
                    Supprimer
                  </button>
                  {event && event.statutEvent !== "ANNULE" ? (
                    <button
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.handleCancelEvent(e);
                      }}
                      class="btn-gradient btn-white"
                      data-dismiss="modal"
                    >
                      Annuler l'événement
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyleRoot>
    );
  }
}
